export default __webpack_public_path__ + "static/media/coloring-icon.98be4808.svg";